import { useGetDealFilterValues } from "@vega-api/generated/deal/deal";
import type { GetProspectsByParams } from "@vega-api/generated/types/getProspectsByParams";
import { m } from "@vega-core/paraglide/messages";
import { useTableFilters } from "@vega-modules/components/Table/TableFilters/hooks/useTableFilters";
import {
  FilterType,
  TableFilterId,
} from "@vega-modules/components/Table/TableFilters/types";

import { type TableFiltersConfig } from "../../../components/Table/TableFilters/types";

export const useProspectsFilters = () => {
  const { data: filterOptions } = useGetDealFilterValues({
    query: {
      select: ({ data }) => data,
    },
  });
  const filtersConfig = {
    filters: [
      {
        id: "searchQuery",
        type: FilterType.Search,
        label: m.coInvestments_filters_search(),
        props: {
          placeholder: m.coInvestments_searchForProspects(),
          className: "w-80 max-w-80",
        },
      },
      {
        id: "limitedPartnerRegion",
        type: FilterType.Dropdown,
        label: m.coInvestments_filters_region(),
        props: {
          placeholder: m.coInvestments_filters_allRegions(),
          options: filterOptions?.regions || [],
        },
      },
    ],
    showResetButton: true,
  } as const satisfies TableFiltersConfig;

  const { filterState, setFilterValue, RenderFilters, hasActiveFilters } =
    useTableFilters({
      id: TableFilterId.CoInvestmentsGP,
      config: filtersConfig,
      isLoading: false,
      syncWithURL: true,
      showSavedFilters: false,
      persistInSession: false,
    });

  const queryParams: Partial<GetProspectsByParams> = {
    searchQuery: filterState.searchQuery,
    limitedPartnerRegion: filterState.limitedPartnerRegion?.value,
  };

  return {
    filterState,
    setFilterValue,
    RenderFilters,
    hasActiveFilters,
    queryParams,
  };
};
